import type { CanMatchFn } from '@angular/router';

import { environment } from '@rpgc-ai/environments';

/** Пока среда не включила «Подборку», маршрут не совпадает и адрес уходит на страницу 404. */
export function isDiscoverPageEnabled(flag: boolean | undefined): boolean {
  return flag === true;
}

export const discoverPageGuard: CanMatchFn = () => isDiscoverPageEnabled(environment.DISCOVER_PAGE_ENABLED);
